import {
  Checkbox,
  DetailsListLayoutMode,
  IColumn,
  ITextFieldStyles,
  ITooltipHostStyles,
  Icon,
  IconButton,
  Label,
  MessageBar,
  MessageBarType,
  Modal,
  PrimaryButton,
  SelectionMode,
  Stack,
  StackItem,
  Sticky,
  StickyPositionType,
  TextField,
  TooltipHost,
  mergeStyleSets,
} from "@fluentui/react";
import styles from "./companyManagement.module.scss";
import { useBoolean } from "@fluentui/react-hooks";
import { useEffect, useMemo, useState } from "react";
import Editor from "react-simple-wysiwyg";
// import { AcceptIcon } from "@fluentui/react-icons-mdl2";
import { ICompany } from "../../../../common/models/ICompany";
import { ICommon } from "../../../../common/models/ICommon";
import CommonService from "../../../../common/api-services/CommonService";
import Pagination from "../../../common/pagination/Pagination";
import ResizableDetailsList from "../../../common/resizableDetailsList/ResizableDetailsList";
import { useNavigate } from "react-router-dom";
const CompanyManagement = () => {
  const service = useMemo(() => new CommonService(), []);
  const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] =
    useBoolean(false);
  const [
    isLoadingCompanies,
    { setTrue: startLoadingCompanies, setFalse: stopLoadingCompanies },
  ] = useBoolean(true);
  const [message, setMessage] = useState<string>("");
  const [messageBarType, setMessageBarType] = useState<MessageBarType>();
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(10);
  const [items, setItems] = useState<ICompany[]>([]);
  const [companyFiltered, setCompanyFiltred] = useState<ICompany[]>([]);
  const [commonItems, setCommonItems] = useState<ICommon[]>([]);
  const [edit, isEdit] = useState<boolean>(false);
  const [html, setHtml] = useState("");
  const [companyToDelete, setCompanyToDelete] = useState<string>("");

  const [errorMessageFieldRequired, setErrorMessageFieldRequired] =
    useState<string>("");
  const [commonCompany, setCommonCompany] = useState<ICommon>({
    id: crypto.randomUUID(),
    typeId: "Company",
    company: { companyId: crypto.randomUUID() },
    tac: { tacId: "" },
  });
  const [commonTac, setCommonTac] = useState<ICommon>({
    id: crypto.randomUUID(),
    typeId: "TAC",
    company: { companyId: "" },
    tac: { tacId: crypto.randomUUID() },
  });
  let navigate = useNavigate();
  const calloutProps = { gapSpace: 0 };
  const hostStyles: Partial<ITooltipHostStyles> = {
    root: { display: "inline-block" },
  };
  const contentStyles = mergeStyleSets({
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
      border: "1px solid",
      minHeight: "400px",
      minWidth: "600px",
      borderRadius: "25px",
      maxHeight: "auto",
    },
    deleteContainer: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
      border: "1px solid",
      minHeight: "120px",
      minWidth: "250px",
      borderRadius: "25px",
    },
  });
  const textfieldStyles: Partial<ITextFieldStyles> = {
    root: {
      width: 350,
      paddingRight: 50,
      paddingBottom: 10,
    },
  };
  const columns: IColumn[] = [
    {
      key: "column3",
      name: "Country",
      fieldName: "country",
      minWidth: 100,
      maxWidth: 150,
      isRowHeader: true,
    },
    {
      key: "column2",
      name: "Entity name",
      fieldName: "companyName",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
    },
    {
      key: "column1",
      name: "Entity code",
      fieldName: "companyCode",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
    },
    {
      key: "column4",
      name: "Active",
      fieldName: "active",
      minWidth: 60,
      maxWidth: 50,
      data: "boolean",
      isRowHeader: true,
      onRender: (item: any) => {
        return (
          <>
            {item.active === true && (
              <Stack horizontalAlign="start" style={{ paddingLeft: 12 }}>
                <Icon iconName="AcceptIcon"></Icon>
              </Stack>
            )}
          </>
        );
      },
    },
    {
      key: "column8",
      name: "",
      fieldName: "",
      minWidth: 100,
      maxWidth: 100,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        return (
          <Stack horizontal horizontalAlign="end">
            <TooltipHost
              content="Edit Terms"
              calloutProps={calloutProps}
              styles={hostStyles}
            >
              <IconButton
                iconProps={{ iconName: "Edit" }}
                className={styles.actionIconButton}
                onClick={() => {
                  onClickEditIcon(item);
                }}
              />
            </TooltipHost>
            <TooltipHost
              content="Delete Terms"
              calloutProps={calloutProps}
              styles={hostStyles}
            >
              <IconButton
                iconProps={{ iconName: "Delete" }}
                className={styles.actionIconButton}
                onClick={() => {
                  const compCommonItem = commonItems?.find(
                    (ci) => ci.company?.companyId === item.companyId,
                  );
                  if (compCommonItem?.id) setCompanyToDelete(compCommonItem.id);
                }}
              />
            </TooltipHost>
          </Stack>
        );
      },
    },
  ];

  function onChange(e: { target: { value: string } }) {
    setHtml(e.target.value);
    let obj = commonTac.tac;
    if (obj) {
      obj = { ...obj, tacContent: e.target.value };
      setCommonTac({ ...commonTac, tac: obj });
    }
  }
  const onChangeTxtField = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string,
    newValue?: string,
  ): void => {
    let obj: any = commonCompany;
    if (obj.company) {
      obj.company[field] =
        field == "companyCode"
          ? newValue?.trim().replace(/[^a-zA-Z ]/g, "")
          : newValue;
      setCommonCompany({ ...commonCompany, company: obj.company });
    }
  };
  const onChangeCheckBox = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    checked?: boolean,
  ) => {
    let obj = commonCompany;
    if (obj.company) {
      obj.company.active = checked;
      setCommonCompany({ ...commonCompany, company: obj.company });
    }
  };
  const onSaveCompany = () => {
    let objCompany = commonCompany.company;
    let objTac = commonTac.tac;
    if (objCompany) objCompany.tacId = objTac?.tacId;
    if (objTac) {
      objTac.companyId = objCompany?.companyId;
      objTac.companyCode = objCompany?.companyCode;
      objTac.isCurrent = true;
      objTac.tacValidFrom = new Date();
    }
    let resCommonCompany = { ...commonCompany, company: objCompany };
    let resCommonTac = { ...commonTac, tac: objTac };
    if (
      resCommonCompany.company?.companyCode &&
      resCommonCompany.company.companyName &&
      resCommonCompany.company.country
    ) {
      setErrorMessageFieldRequired("");
      service
        .Create([resCommonCompany, resCommonTac] as ICommon[])
        .then((result: any) => {
          if (result?.error) {
            setMessageBarType(MessageBarType.error);
            setMessage(`Error: ${result?.error}`);
          } else {
            setMessageBarType(MessageBarType.success);
            setMessage(`Company added successfully`);
            getCompanies();
          }
          resetModal();
        });
    } else {
      setErrorMessageFieldRequired("Field is required");
    }
  };
  const onEditCompany = () => {
    if (
      commonCompany.company?.companyCode &&
      commonCompany.company.companyName &&
      commonCompany.company.country
    ) {
      setErrorMessageFieldRequired("");
      service.Update(commonCompany).then((result: any) => {
        if (result?.error) {
          setMessageBarType(MessageBarType.error);
          setMessage(`Error: ${result?.error}`);
        } else {
          getCompanies();
          service.Update(commonTac).then((result: any) => {
            if (result?.error) {
              setMessageBarType(MessageBarType.error);
              setMessage(`Error: ${result?.error}`);
            } else {
              setMessageBarType(MessageBarType.success);
              setMessage(`Terms updated successfully`);
            }
          });
        }
        resetModal();
      });
    } else {
      setErrorMessageFieldRequired("Field is required");
    }
  };
  const changeCurrentPage = (newPageNumber: number) => {
    setCurrentPage(newPageNumber);
  };
  const getCompanies = () => {
    startLoadingCompanies();
    service
      .GetAllCompanies()
      .then((data: any[]) => {
        if (data) {
          data = data.sort((a, b) =>
            a.company.country.localeCompare(b.company.country),
          );
          setCommonItems(data);
          let companies: ICompany[] = [];
          data
            .filter((e) => !e.company.isDeleted)
            .forEach((e) => {
              companies.push(e.company);
            });
          if (companies.length > 0) {
            setItems(companies);
          }
        }
      })
      .finally(() => {
        stopLoadingCompanies();
      });
  };
  const resetModal = () => {
    hideModal();
    setCommonCompany({
      id: crypto.randomUUID(),
      typeId: "Company",
      company: { companyId: crypto.randomUUID() },
      tac: { tacId: "" },
    });
    setCommonTac({
      id: crypto.randomUUID(),
      typeId: "TAC",
      company: { companyId: "" },
      tac: { tacId: crypto.randomUUID() },
    });
    setHtml("");
  };

  const onClickEditIcon = (item: ICompany) => {
    let com = commonItems.find((x) => {
      return x.company?.companyId == item.companyId;
    });
    if (com) setCommonCompany(com);
    if (item.tacId) {
      service.GetTacbyTacId(item.tacId).then((data: any) => {
        if (data?.error) {
          setMessageBarType(MessageBarType.error);
          setMessage(`Error: ${data?.error}`);
        } else {
          console.log(data);
          isEdit(true);
          showModal();
          setCommonTac(data);

          if (data?.tac.tacContent) {
            setHtml(data?.tac.tacContent);
          }
        }
      });
    }
  };

  const filterCompanies = () => {
    if (items.length > 0) {
      if (items.length < pageSize) {
        setTotalPages(1);
      } else {
        setTotalPages(Math.ceil(items.length / pageSize));
      }
      setCompanyFiltred(
        items.slice((currentPage - 1) * pageSize, currentPage * pageSize),
      );
    }
  };

  const onDeleteCompany = (id: string) => {
    let compCommonItem = commonItems.find((ci) => ci.id === id);
    if (!compCommonItem?.id || !compCommonItem.company?.companyId) return;

    compCommonItem.company.isDeleted = true;

    console.log("Deleting company with id:", compCommonItem);
    service.Update(compCommonItem).then((result: any) => {
      if (result?.error) {
        setMessageBarType(MessageBarType.error);
        setMessage(`Error: ${result?.error}`);
      } else {
        setMessageBarType(MessageBarType.success);
        setMessage(`Terms deleted successfully`);
        getCompanies();
      }
      setCompanyToDelete("");
    });
  };

  useEffect(() => {
    getCompanies();
    const localCurrentUser = localStorage.getItem("currentUser");
    if (typeof localCurrentUser === "string") {
      const user = JSON.parse(localCurrentUser);
      if (
        user.isLegal == false ||
        user == undefined ||
        user.isLegal == undefined
      ) {
        navigate("/notfound");
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    filterCompanies();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, currentPage]);
  return (
    <>
      <Stack>
        <Stack horizontal horizontalAlign="space-between">
          <Stack horizontal horizontalAlign="start">
            <Label className={styles.PageHeader}>Terms management</Label>
          </Stack>
        </Stack>

        <Stack>
          <hr className={styles.horizontalLine}></hr>
        </Stack>
        {message != "" && (
          <Stack>
            <MessageBar
              messageBarType={messageBarType}
              isMultiline={true}
              dismissButtonAriaLabel="Close"
              onDismiss={() => {
                setMessage("");
                setMessageBarType(undefined);
              }}
            >
              {message}
            </MessageBar>
          </Stack>
        )}
        <Stack horizontal horizontalAlign="space-between">
          <Label className={styles.contentHeader}>
            Terms management by RB entity
          </Label>

          <TooltipHost
            content="Add new Terms"
            // This id is used on the tooltip itself, not the host
            // (so an element with this id only exists when the tooltip is shown)
            // id={tooltipArchiveId}
            calloutProps={calloutProps}
            styles={hostStyles}
          >
            <IconButton
              iconProps={{ iconName: "Add" }}
              className={styles.btnAddItem}
              onClick={showModal}
            ></IconButton>
          </TooltipHost>
        </Stack>
        <Modal
          isOpen={!!companyToDelete}
          isBlocking={false}
          containerClassName={contentStyles.deleteContainer}
          onDismiss={() => {
            setCompanyToDelete("");
          }}
        >
          {companyToDelete && (
            <Stack style={{ padding: 20 }}>
              <Label className={styles.contentHeader}>
                You are about to delete the selected Terms
              </Label>
              <Stack gap={16} horizontal horizontalAlign="center">
                <PrimaryButton
                  text="Confirm"
                  className={styles.buttonSave}
                  onClick={() => onDeleteCompany(companyToDelete)}
                />
                <PrimaryButton
                  text="Cancel"
                  className={styles.buttonCancel}
                  onClick={() => {
                    setCompanyToDelete("");
                  }}
                />
              </Stack>
            </Stack>
          )}
        </Modal>
        <Stack>
          <StackItem>
            <ResizableDetailsList
              items={companyFiltered}
              enableShimmer={isLoadingCompanies}
              compact={false}
              columns={columns}
              selectionMode={SelectionMode.none}
              setKey="none"
              layoutMode={DetailsListLayoutMode.fixedColumns}
              isHeaderVisible={true}
            />
          </StackItem>
          <Sticky stickyPosition={StickyPositionType.Footer}>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onChange={changeCurrentPage}
            />
          </Sticky>
        </Stack>
      </Stack>
      <Modal
        isOpen={isModalOpen}
        onDismiss={hideModal}
        isBlocking={false}
        containerClassName={contentStyles.container}
      >
        <Stack style={{ padding: 20 }}>
          <Label className={styles.contentHeader}>
            Terms management by RB entity
          </Label>
          <Stack>
            <hr className={styles.horizontalLine}></hr>
          </Stack>
          <Stack horizontal horizontalAlign="start">
            <TextField
              label="Country"
              value={commonCompany.company?.country}
              required
              styles={textfieldStyles}
              errorMessage={
                commonCompany.company?.country == "" ||
                commonCompany.company?.country == undefined
                  ? errorMessageFieldRequired
                  : undefined
              }
              onChange={(ev, val) => {
                onChangeTxtField(ev, "country", val);
              }}
            />
            <TextField
              label="Entity name"
              value={commonCompany.company?.companyName}
              required
              styles={textfieldStyles}
              errorMessage={
                commonCompany.company?.companyName == "" ||
                commonCompany.company?.companyName == undefined
                  ? errorMessageFieldRequired
                  : undefined
              }
              onChange={(ev, val) => {
                onChangeTxtField(ev, "companyName", val);
              }}
            />
            <TextField
              label="Entity code"
              value={commonCompany.company?.companyCode}
              required
              styles={textfieldStyles}
              errorMessage={
                commonCompany.company?.companyCode == "" ||
                commonCompany.company?.companyCode == undefined
                  ? errorMessageFieldRequired
                  : undefined
              }
              onChange={(ev, val) => {
                onChangeTxtField(ev, "companyCode", val);
              }}
            />

            <Checkbox
              label="Active"
              styles={{ root: { alignItems: "end", paddingBottom: 12 } }}
              onChange={onChangeCheckBox}
              checked={commonCompany.company?.active}
            ></Checkbox>
          </Stack>
          <Stack horizontal horizontalAlign="start">
            <TextField
              label="Address"
              value={commonCompany.company?.address}
              styles={textfieldStyles}
              errorMessage={
                commonCompany.company?.address == "" ||
                commonCompany.company?.address == undefined
                  ? errorMessageFieldRequired
                  : undefined
              }
              onChange={(ev, val) => {
                onChangeTxtField(ev, "address", val);
              }}
            />
            <TextField
              label="Zip"
              value={commonCompany.company?.zip}
              styles={textfieldStyles}
              errorMessage={
                commonCompany.company?.zip == "" ||
                commonCompany.company?.zip == undefined
                  ? errorMessageFieldRequired
                  : undefined
              }
              onChange={(ev, val) => {
                onChangeTxtField(ev, "zip", val);
              }}
            />
            <TextField
              label="City"
              value={commonCompany.company?.city}
              styles={textfieldStyles}
              errorMessage={
                commonCompany.company?.city == "" ||
                commonCompany.company?.city == undefined
                  ? errorMessageFieldRequired
                  : undefined
              }
              onChange={(ev, val) => {
                onChangeTxtField(ev, "city", val);
              }}
            />
          </Stack>
          <Stack>
            <hr className={styles.horizontalLine}></hr>
          </Stack>
          <Label className={styles.contentHeader}>Terms</Label>
          <Stack>
            <Editor
              value={html}
              onChange={onChange}
              style={{ maxHeight: 300, overflow: "auto" }}
            />
          </Stack>
          <Stack horizontal horizontalAlign="end" style={{ paddingTop: 20 }}>
            <PrimaryButton
              text={!edit ? "Add" : "Edit"}
              className={styles.buttonSave}
              disabled={false}
              onClick={!edit ? onSaveCompany : onEditCompany}
            />
            <PrimaryButton
              text="Cancel"
              className={styles.buttonCancel}
              onClick={hideModal}
            />
          </Stack>
        </Stack>
      </Modal>
    </>
  );
};
export default CompanyManagement;
